import { render, staticRenderFns } from "./longUrlGroupManage.vue?vue&type=template&id=783547f0&scoped=true"
import script from "./longUrlGroupManage.vue?vue&type=script&lang=js"
export * from "./longUrlGroupManage.vue?vue&type=script&lang=js"
import style0 from "./longUrlGroupManage.vue?vue&type=style&index=0&id=783547f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783547f0",
  null
  
)

export default component.exports